import { collection, get, update } from "typesaurus"

export type UsageBreakdown = {
  completed_count: number
  usage: number
}

export type ProgramTypes = "ACT"
export type ProductTypes =
  | "TruScore"
  | "Study Hall"
  | "Mastery Curriculum"
  | "SnapCourse"
  | "Elements"

type SchoolType = {
  id: string
  name: string
}
export interface ReportsUsage {
  id: string
  created_date: number
  startDate?: number
  endDate?: number
  download_link?: string
  grades: Array<string>
  group_id: string
  last_run?: number
  name: string
  type: "District" | "School"
  status: string
  products: Array<ProductTypes>
  programs: Array<ProgramTypes>
  schools: Array<SchoolType>
  artifacts?: Array<string>
  failed_reason?: string
  active_students?: number
  rostered_students?: number
  total_usage?: number
  average_usage?: number
  truscore_usage?: number
  truscore_count?: number
  snapcourse_count?: number
  snapcourse_usage?: number
  study_hall_usage?: number
  study_hall_count?: number
  masterycurriculum_usage?: number
  mastery_curriculum_count?: number
  events?: Array<string>
  eventsProcessed?: Array<string>
  district: string
  school?: string
}

const collection_ref = collection<ReportsUsage>("reports_usage")

export const getReportsUsageById = (id: string) => {
  return get(collection_ref, id)
}

export const updateReportsUsageById = (
  id: string,
  newVals: Partial<ReportsUsage>
) => {
  return update(collection_ref, id, newVals)
}
